export const CALENDAR_PROVIDERS = {
  GOOGLE: "google",
  OUTLOOK: "outlook",
};
